import { addProductVulcan } from '../../vulcanPricing/customerInformation/customerInformationFieldNames';
import { applyBusinessWifiBundleRateToLabels } from '../../vulcanPricing/businessWifi/businessWifiBundleRate';

/**
 * Forms-core counterpart of the legacy render-loop call to
 * `applyBusinessWifiBundleRateToLabels` (SOF-3490): rewrites the $20 Business
 * Wi-Fi price printed in the Add Product option label to the bundled rate.
 * Pricing itself is corrected in `vulcanPricing.js`.
 *
 * @returns {import('../vulcanFieldRules').VulcanRule}
 */
export function makeBusinessWifiBundleLabelRule() {
  return (field, state, values) => {
    const input = { ...state };
    const output = applyBusinessWifiBundleRateToLabels(input, {
      [addProductVulcan]: { value: values[addProductVulcan] }
    });
    if (output === input) return undefined;
    return { options: output.options };
  };
}

export default makeBusinessWifiBundleLabelRule;
